import React from 'react';

const RecipesListPage = React.lazy(() => import('@apps/Recipes/pages/RecipesListPage'));
const RecipeAddPage = React.lazy(() => import('@apps/Recipes/pages/RecipeAddPage'));
const RecipeEditPage = React.lazy(() => import('@apps/Recipes/pages/RecipeEditPage'));
const RecipeOnePage = React.lazy(() => import('@apps/Recipes/pages/RecipeOnePage'));

import { IPohodnikRouterItem } from '.';

const recipesRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/recipes',
    component: () => <RecipesListPage />,
    title: 'Список рецептов',
  },
  {
    path: '/recipes/add',
    component: () => <RecipeAddPage />,
    protected: true,
    title: 'Добавление рецепта',
  },

  {
    path: '/recipes/:id/edit',
    component: ({
      match: {
        params: { id },
      },
    }) => <RecipeEditPage id_recipe={+id} />,
    protected: false,
    title: 'Редактирование рецепта',
  },
  {
    path: '/recipes/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <RecipeOnePage id_recipe={+id} />,
    protected: false,
    title: 'Просмотр рецепта',
  },
];

export default recipesRoutes;
